import { formatDate } from '@angular/common';
import { DateRange } from '@angular/material/datepicker';
import Autolinker from 'autolinker';
import { MoodsService } from "../timeline/timeline-item/moods/moods.service";
import { Mood } from "@teammood/timeline";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class  CalendarService {

    constructor(
        private http: HttpClient, 
        private moodsService: MoodsService
    ) {}

    build_params(dateRange: DateRange<Date>, tags: any[], tagsCombinator: string) {
        const params:any = {
            start: formatDate(dateRange.start,'dd-MM-yyyy', 'fr'),
            end: formatDate(dateRange.end,'dd-MM-yyyy', 'fr'),
        };

        if (tags) {
            params.tags = tags.map(tag => {
                return tag.name;
            })
        }
        if (tagsCombinator === 'any' || tagsCombinator === 'all') {
            params.tagscombinator = tagsCombinator;
        }
        return params;
    }

    /**
     * Give the days and team/user timeline "options"
     * @param { dateRange } dateRange start and end
     * @param { String } teamId
     * @param { Array } tags
     * @param { String } [tagsCombinator]
     * @returns { Promise }
     */
    async moodsCalendar(dateRange: DateRange<Date>, teamId, tags, tagsCombinator) {
        const params = this.build_params(dateRange, tags, tagsCombinator);
        const response = await firstValueFrom(this.http.get('/api/' + teamId + '/moods', {params: params}));
        return response;
    }

    daysWithTransformedMoodsForCalendar(data) {
        const filteredData = data. filter((day) => {
            return day.values.length > 0;
        })

        const transformedData = filteredData.map((day) => {
            return {
                'date': day.date,
                'today': day.today,
                'participation_rate': day.participationRate,
                'values': day.values.map(mood => this.transformMoodForCalendar(mood, day.nativeDate))
            };
        });

        return transformedData;
    }

    private transformMoodForCalendar(mood: Mood, date) {
        const transformedMood:any = {
            'id': mood.id,
            'mood': mood.mood,
            'icon': this.moodsService.build_icon(mood.mood, date),
            'tags': mood.tags,
        };

        if(mood.comment){
            transformedMood.comment = mood.comment;
            transformedMood.comment.body = this.moodsService.sanitizeComment(mood.comment.body);
        }

        return transformedMood;
    }

}